import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { TranslateService } from "@ngx-translate/core";
import { MatTableDataSource } from "@angular/material/table";

export interface LedgerData{
  supplierCode:any; partNumber:any; location:any; deliveryPoint:any;nextProcess:any;packageCode:any;delAddress:any;specification:any;
}

@Component({
  selector: "app-po-ledger-daily",
  templateUrl: "./po-ledger-daily.component.html",
  styleUrls: ["./po-ledger-daily.component.scss"]
})
export class PoLedgerDailyComponent implements OnInit {
  exportData: any;
  poFixedDates: any;
  enableExport: boolean = false;
  poFixedExportData: any;
  supPoint: any[];
  locCode: any[];
  volumeSelected: boolean = false;
  weightSelected: boolean = false;
  last30Columns: any[];
  new30Columns: any;
  new30Column: any[];
  first10daysData: any[];
  dateFormatData: any = [];
  dateFormat1Data: any = [];
  dateFormat2Data: any = [];
  dateFormat: string;
  newColumns: any[];
  headerDate: any;
  allDates: any[];
  poFixed: any;
  poFixedData: any[];
  suppCodeList: any[];
  dropdownSettings: any;
  locCodeTbl: any;
  suppCodeTbl: any;
  suppCodeTbl1: any;
  locCodeList = [];
  datePipe = new DatePipe("en-US");
  public data: Array<any> = [];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  public rows: Array<any> = [];
  columnSize: any = "Last 30 Days";
  name: string = "All";
  names: string[] = ["All", "Quantity", "Weight", "Volume", "No. Of Boxes"];
  columnFilterValue = ['Last 30 Days', 'Next 30 Days']
  public columnsData: Array<any> = [
    { title: "Supplier Code", name: "supplierCode", sort: '', className: 'poTable' },
    { title: "Part Number", name: "partNumber", sort: '', className: 'poTable' },
    { title: "Location", name: "location", sort: '', className: 'poTable' },
    { title: "Delivery Point", name: "deliveryPoint", sort: '', className: 'poTable' },
    { title: "Next process", name: "nextProcess", sort: '', className: 'poTable' },
    { title: "Package Code", name: "packageCode", sort: '', className: 'poTable' },
    { title: "Delivery Address", name: "delAddress", sort: '', className: 'poTable' },
    { title: "Spec", name: "specification", className: 'poTable' },
  ];

  displayedColumns = ['supplierCode', 'partNumber', 'location', 'deliveryPoint','nextProcess','packageCode','delAddress','specification'];
  dataSource: MatTableDataSource<LedgerData[]>;

  public config: any = {
    paging: true,
    sorting: { columns: this.columnsData },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered', 'poTable']
  };
  constructor(private logbaseService: logbaseService, private spinner: NgxSpinnerService, private ref: ChangeDetectorRef, private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.dropdownSettings = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      // classes: "poFixedMultiSelect",
      limitSelection: 10,
      itemsShowLimit: 4,
      enableCheckAll: true,
      enableSearchFilter: true,
    };
    this.toGetSupplierCode();
    this.getAllDates();
  }

  getAllDates() {
    var today = new Date();
    var priorDateArr = [];
    var nextDateArr = [];
    let dataColumn = [];
    let dateFormat = [];
    let dateFormat1 = [];
    let dateFormat2 = [];
    let first30days = [];
    let last30Days = [];
    let columnSizeSelected = this.columnSize;
    for (let index = 0; index <= 30; index++) {
      let priorDate = new Date().setDate(today.getDate() - index);
      let nextDate = new Date().setDate(today.getDate() + index);
      let priorMonthDate = new Date(priorDate);
      let nextMonthDate = new Date(nextDate);
      priorDateArr.push(priorMonthDate);
      nextDateArr.push(nextMonthDate);
    }
    this.allDates = priorDateArr.concat(nextDateArr);
    let tempDay1 = ['day1', 'day2', 'day3', 'day4', 'day5', 'day6', 'day7', 'day8', 'day9', 'day10', 'day11', 'day12', 'day13', 'day14', 'day15',
      'day16', 'day17', 'day18', 'day19', 'day20', 'day21', 'day22', 'day23', 'day24', 'day25', 'day26', 'day27', 'day28', 'day29', 'day30', 'day31', 'day32',
      'day33', 'day34', 'day35', 'day36', 'day37', 'day38', 'day39', 'day40', 'day41', 'day42', 'day43', 'day44', 'day45', 'day46', 'day47',
      'day48', 'day49', 'day50', 'day51', 'day52', 'day53', 'day54', 'day55', 'day56', 'day57', 'day58', 'day59', 'day60'];
    // for (let k = 0; k < this.allDates.length; k++) {
    // dataColumn.push({
    //   title: this.datePipe.transform(this.allDates[k], 'EE, yyyy-MM-dd'),
    //   name: tempDay1[k]
    // })
    //   dateFormat.push(
    //     this.datePipe.transform(this.allDates[k], 'yyMMdd')
    //   )
    // };
    // this.dateFormatData = dateFormat;
    if (columnSizeSelected == 'Last 30 Days') {
      this.poFixedDates = [];
      this.dateFormatData = [];
      let poLastDatesFormat = [];
      for (let p = 0; p <= 30; p++) {
        first30days.push({
          title: this.datePipe.transform(priorDateArr[p], 'E, yyyy-MM-dd'),
          name: tempDay1[p]
        });
        dateFormat1.push(
          this.datePipe.transform(priorDateArr[p], 'dd-MM-yyyy')
        )
        poLastDatesFormat.push(this.datePipe.transform(priorDateArr[p], 'yyyy-MM-dd'))
        this.columnsData = [];
        this.columnsData = [
          { title: this.translate.instant('Supplier Code'), name: "supplierCode", sort: '' },
          { title: this.translate.instant('Part No'), name: "partNumber", sort: '' },
          { title: this.translate.instant("Location"), name: "location", sort: '' },
          { title: this.translate.instant("Delivery Point"), name: "deliveryPoint", sort: '' },
          { title: this.translate.instant("Line Number"), name: "nextProcess", sort: '' },
          { title: this.translate.instant("Package Code"), name: "packageCode", sort: '' },
          { title: this.translate.instant("Delivery Address"), name: "delAddress", sort: '' },
          { title: this.translate.instant("Spec"), name: "specification" }
        ]
      }
      this.dateFormat1Data = dateFormat1;
      this.dateFormatData = this.dateFormat1Data;
      this.poFixedDates = poLastDatesFormat;
      this.new30Columns = this.columnsData.concat(first30days);
      this.columnsData = this.new30Columns;
      this.onChangeTable(this.config, true);
    }
    // else if (columnSizeSelected == 'Last 30 Days') {
    //   for (let m = 30; m < 60; m++) {
    //     last30Days.push({
    //       title: this.datePipe.transform(this.allDates[m], 'E, yyyy-MM-dd'),
    //       name: tempDay1[m]
    //     });
    //     this.columnsData = [];
    //     this.columnsData = [
    //       { title: "Supplier Code", name: "supplierCode", sort: '' },
    //       { title: "Part Number", name: "partNumber", sort: '' },
    //       { title: "Location", name: "location", sort: '' },
    //       { title: "Delivery Point", name: "deliveryPoint", sort: '' },
    //       { title: "Next process", name: "nextProcess", sort: '' },
    //       { title: "Spec", name: "specification" }
    //     ]
    //   }
    //   this.last30Columns = this.columnsData.concat(last30Days);
    //   this.columnsData = this.last30Columns;
    //   this.onChangeTable(this.config, true);

    // }
    else if (columnSizeSelected == 'Next 30 Days') {
      this.poFixedDates = [];
      this.dateFormatData = [];
      let poNextDatesFormat = [];
      for (let m = 0; m <= 30; m++) {
        last30Days.push({
          title: this.datePipe.transform(nextDateArr[m], 'E, yyyy-MM-dd'),
          name: tempDay1[m]
        });
        dateFormat2.push(
          this.datePipe.transform(nextDateArr[m], 'dd-MM-yyyy')
        );
        poNextDatesFormat.push(this.datePipe.transform(nextDateArr[m], 'yyyy-MM-dd'))

        this.columnsData = [];
        this.columnsData = [
          { title: "Supplier Code", name: "supplierCode", sort: '' },
          { title: "Part Number", name: "partNumber", sort: '' },
          { title: "Location", name: "location", sort: '' },
          { title: "Delivery Point", name: "deliveryPoint", sort: '' },
          { title: "Next process", name: "nextProcess", sort: '' },
          { title: "Package Code", name: "packageCode", sort: '' },
          { title: "Delivery Address", name: "delAddress", sort: '' },

          { title: "Spec", name: "specification" }
        ]
      }
      this.dateFormat2Data = dateFormat2;
      this.dateFormatData = this.dateFormat2Data;
      this.poFixedDates = poNextDatesFormat;
      this.last30Columns = this.columnsData.concat(last30Days);
      this.columnsData = this.last30Columns;
      this.onChangeTable(this.config, true);

    }
    // this.newColumns = this.columnsData.concat(dataColumn);
    // this.columnsData = this.newColumns;
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columnsData.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }

    });

    if (!config.filtering) {
      return filteredData;
    }


    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columnsData.forEach((column: any) => {
        if ((item[column.name] ? item[column.name] : '').toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;
    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;
    let locSelected = [];
    let suppSelected = [];
    let allselected = this.name;
    this.setFilterData(page.page);
    if (page.page == undefined || page.page == null) {
      pageNo = 0;
    } else {
      if (page.page != 0) {
        pageNo = page.page - 1;
      }
    }

    if (this.suppCodeTbl || this.locCodeTbl) {
      if ((this.suppCodeTbl.length > 0 && this.suppCodeTbl.length <= 10) || (this.locCodeTbl.length > 0 && this.locCodeTbl.length <= 10)) {
        if (this.name != 'All') {
          this.enableExport = true;
        } else {
          this.enableExport = false;
        }
      } else {
        this.enableExport = false;
      }
    };

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else {
        sortData = {
          name: "",
          sort: ""
        };
      }
    });
    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {
      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }
    if (this.suppCodeTbl1) {

    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }
    var dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filterString,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      location: locSelected,
      suplierCode: suppSelected
    }

    this.logbaseService.getPoFixedDaily(dataToSend)
      .subscribe(result => {
        this.poFixed = result;
        var mydata: any = result;
        var poData = mydata.response.content;
        var finalobj = [];
        poData.forEach(x => {
          var obj: any = {};
          var dlyAddress;
          var shpPrefecture, shpStreet, shpCity, shpCountry, shpZipcode;
          if (x.shippingInfoList != null) {
            if (x.shippingInfoList[0] != null) {
             


              if (x.shippingInfoList[0].shippingPointaddrPrefecture) {
                shpPrefecture = x.shippingInfoList[0].shippingPointaddrPrefecture + ', ';
              } else {
                shpPrefecture = '';
              }
              if (x.shippingInfoList[0].shippingPointaddrStreet) {
                shpStreet = x.shippingInfoList[0].shippingPointaddrStreet + ', ';
              } else {
                shpStreet = '';
              }
              if (x.shippingInfoList[0].shippingPointaddrCity) {
                shpCity = x.shippingInfoList[0].shippingPointaddrCity + ', ';
              } else {
                shpCity = '';
              }
              if (x.shippingInfoList[0].shippingPointaddrCountry) {
                shpCountry = x.shippingInfoList[0].shippingPointaddrCountry + ', ';
              } else {
                shpCountry = '';
              }
              if (x.shippingInfoList[0].shippingPointaddrZipCode) {
                shpZipcode = x.shippingInfoList[0].shippingPointaddrZipCode;
              } else {
                shpZipcode = '';
              }
              dlyAddress = shpPrefecture + "" + shpStreet + "" + shpCity + "" + shpCountry + "" + shpZipcode;
            }

            if (x.shippingInfoList.length == 0) {
              dlyAddress = "";
            }
          } else {
            dlyAddress = "";
          }

          obj.supplierCode = x.supplierCode;
          obj.packageId = x.packageId;
          obj.partNumber = x.partNumber;
          obj.plantName = x.plantName;
          obj.deliveryPoint = x.deliveryPoint;
          obj.nextProcess = x.nextProcess;
          obj.packageCode = x.packageCode;
          obj.delAddress = dlyAddress;

          obj.month1Details = x.month1Details;
          obj.month2Details = x.month2Details;
          obj.month3Details = x.month3Details;
          obj.month4Details = x.month4Details;
          obj.month5Details = x.month5Details;
          obj.month6Details = x.month6Details;
          obj.month7Details = x.month7Details;
          obj.month8Details = x.month8Details;
          obj.month9Details = x.month9Details;
          obj.month10Details = x.month10Details;
          obj.month11Details = x.month11Details;
          obj.month12Details = x.month12Details;

          finalobj.push(obj);
        });
        finalobj.forEach(x => {
          x.datesdata = [];
          var flattened1 = [].concat.apply([], x.month1Details);
          var flattened2 = [].concat.apply([], x.month2Details);
          var flattened3 = [].concat.apply([], x.month3Details);
          var flattened4 = [].concat.apply([], x.month4Details);
          var flattened5 = [].concat.apply([], x.month5Details);
          var flattened6 = [].concat.apply([], x.month6Details);
          var flattened7 = [].concat.apply([], x.month7Details);
          var flattened8 = [].concat.apply([], x.month8Details);
          var flattened9 = [].concat.apply([], x.month9Details);
          var flattened10 = [].concat.apply([], x.month10Details);
          var flattened11 = [].concat.apply([], x.month11Details);
          var flattened12 = [].concat.apply([], x.month12Details);
          x.datesdata = flattened1.concat(flattened2).concat(flattened3).concat(flattened4).concat(flattened5).concat(flattened6).concat(flattened7).concat(flattened8).concat(flattened9).concat(flattened10).concat(flattened11).concat(flattened12);
        });
        finalobj.forEach(x => {
          x.datesdata = x.datesdata.filter(y => {
            return this.dateFormatData.includes(y.date);
          })
        });
        var partArr;
        var partsData = [];
        this.spinner.hide();

        // finalobj.forEach(obj => {
        //   var myobj = {}
        //   for (var x = 1; x <= 60; x++) {
        //     var innerobj = obj.datesdata.find(y => {
        //       return this.dateFormatData[x + 1] == y.date;
        //     }) != undefined ? obj.datesdata.find(y => {
        //       return this.dateFormatData[x + 1] == y.date;
        //     }) : { totalWeight: 0, Volume: 0, totalVolume: 0, totalQuantity: 0, totalNumberOfBox: 0 };
        //     myobj["day" + "" + x] = { weight: innerobj.totalWeight, Volume: innerobj.totalVolume, Quantity: innerobj.totalQuantity, totalNumberofBoxes: innerobj.totalNumberOfBox };
        //   }
        //   obj.obj1 = myobj;
        // });
        finalobj.forEach(obj => {
          var myobj = {}
          for (var x = 1; x <= 31; x++) {
            var innerobj = obj.datesdata.find(y => {
              return this.dateFormatData[x - 1] == y.date;
            }) != undefined ? obj.datesdata.find(y => {
              return this.dateFormatData[x - 1] == y.date;
            }) : { totalWeight: 0, Volume: 0, totalVolume: 0, totalQuantity: 0, totalNumberOfBox: 0 };
            myobj["day" + "" + x] = { weight: innerobj.totalWeight, Volume: innerobj.totalVolume, Quantity: innerobj.totalQuantity, totalNumberofBoxes: innerobj.totalNumberOfBox };
          }
          obj.obj1 = myobj;
        });
        finalobj.forEach(function (value, key) {

          if (allselected == 'Weight') {

            partArr = {
              supplierCode: value.supplierCode,
              partNumber: value.partNumber,
              nextProcess: value.nextProcess,
              location: value.plantName,
              deliveryPoint: value.deliveryPoint,
              packageCode: value.packageCode || '',
              delAddress: value.delAddress,
              day1: '<td><div class="fullRow">' + value.obj1.day1.weight + '</div></td>',
              day2: '<td "><div class="fullRow" >' + value.obj1.day2.weight + '</div></td>',
              day3: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.weight + '</div></td>',
              day4: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.weight + '</div></td>',
              day5: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.weight + '</div></td>',
              day6: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.weight + '</div></td>',
              day7: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.weight + '</div></td>' + '</div></td>',
              day8: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.weight + '</div></td>' + '</div></td>',
              day9: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.weight + '</div></td>',
              day10: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.weight + '</div></td>',
              day11: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.weight + '</div></td>',
              day12: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.weight + '</div></td>',
              day13: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.weight + '</div></td>',
              day14: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.weight + '</div></td>',
              day15: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.weight + '</div></td>',
              day16: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.weight + '</div></td>',
              day17: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.weight + '</div></td>',
              day18: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.weight + '</div></td>',
              day19: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.weight + '</div></td>',
              day20: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.weight + '</div></td>',
              day21: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.weight + '</div></td>',
              day22: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.weight + '</div></td>',
              day23: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.weight + '</div></td>',
              day24: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.weight + '</div></td>',
              day25: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.weight + '</div></td>',
              day26: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.weight + '</div></td>',
              day27: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.weight + '</div></td>',
              day28: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.weight + '</div></td>',
              day29: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.weight + '</div></td>',
              day30: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.weight + '</div></td>',
              day31: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.weight + '</div></td>',
              specification:
                '<td class="no-pad rmPad"><div class="fullRow">Weight(Kg)</div></td>'
            };
          }
          else if (allselected == 'Volume') {

            partArr = {
              supplierCode: value.supplierCode,
              partNumber: value.partNumber,
              nextProcess: value.nextProcess,
              location: value.plantName,
              deliveryPoint: value.deliveryPoint,
              packageCode: value.packageCode || '',
              delAddress: value.delAddress,
              day1: '<td><div class="fullRow">' + value.obj1.day1.Volume + '</div></td>',
              day2: '<td "><div class="fullRow" >' + value.obj1.day2.Volume + '</div></td>',
              day3: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.Volume + '</div></td>',
              day4: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.Volume + '</div></td>',
              day5: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.Volume + '</div></td>',
              day6: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.Volume + '</div></td>',
              day7: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.Volume + '</div></td>' + '</div></td>',
              day8: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.Volume + '</div></td>' + '</div></td>',
              day9: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.Volume + '</div></td>',
              day10: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.Volume + '</div></td>',
              day11: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.Volume + '</div></td>',
              day12: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.Volume + '</div></td>',
              day13: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.Volume + '</div></td>',
              day14: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.Volume + '</div></td>',
              day15: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.Volume + '</div></td>',
              day16: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.Volume + '</div></td>',
              day17: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.Volume + '</div></td>',
              day18: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.Volume + '</div></td>',
              day19: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.Volume + '</div></td>',
              day20: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.Volume + '</div></td>',
              day21: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.Volume + '</div></td>',
              day22: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.Volume + '</div></td>',
              day23: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.Volume + '</div></td>',
              day24: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.Volume + '</div></td>',
              day25: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.Volume + '</div></td>',
              day26: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.Volume + '</div></td>',
              day27: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.Volume + '</div></td>',
              day28: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.Volume + '</div></td>',
              day29: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.Volume + '</div></td>',
              day30: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.Volume + '</div></td>',
              day31: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.Volume + '</div></td>',
              specification:
                '<td class="no-pad rmPad"><div class="fullRow">Volume(mm3)</div></td>'
            };
          }
          else if (allselected == 'Quantity') {

            partArr = {
              supplierCode: value.supplierCode,
              partNumber: value.partNumber,
              nextProcess: value.nextProcess,
              location: value.plantName,
              deliveryPoint: value.deliveryPoint,
              packageCode: value.packageCode || '',
              delAddress: value.delAddress,
              day1: '<td><div class="fullRow">' + value.obj1.day1.Quantity + '</div></td>',
              day2: '<td "><div class="fullRow" >' + value.obj1.day2.Quantity + '</div></td>',
              day3: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.Quantity + '</div></td>',
              day4: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.Quantity + '</div></td>',
              day5: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.Quantity + '</div></td>',
              day6: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.Quantity + '</div></td>',
              day7: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.Quantity + '</div></td>' + '</div></td>',
              day8: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.Quantity + '</div></td>' + '</div></td>',
              day9: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.Quantity + '</div></td>',
              day10: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.Quantity + '</div></td>',
              day11: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.Quantity + '</div></td>',
              day12: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.Quantity + '</div></td>',
              day13: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.Quantity + '</div></td>',
              day14: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.Quantity + '</div></td>',
              day15: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.Quantity + '</div></td>',
              day16: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.Quantity + '</div></td>',
              day17: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.Quantity + '</div></td>',
              day18: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.Quantity + '</div></td>',
              day19: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.Quantity + '</div></td>',
              day20: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.Quantity + '</div></td>',
              day21: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.Quantity + '</div></td>',
              day22: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.Quantity + '</div></td>',
              day23: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.Quantity + '</div></td>',
              day24: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.Quantity + '</div></td>',
              day25: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.Quantity + '</div></td>',
              day26: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.Quantity + '</div></td>',
              day27: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.Quantity + '</div></td>',
              day28: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.Quantity + '</div></td>',
              day29: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.Quantity + '</div></td>',
              day30: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.Quantity + '</div></td>',
              day31: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.Quantity + '</div></td>',
              specification:
                '<td class="no-pad rmPad"><div class="fullRow">Quantity</div></td>'
            };
          }
          else if (allselected == 'No. Of Boxes') {
            partArr = {
              supplierCode: value.supplierCode,
              partNumber: value.partNumber,
              nextProcess: value.nextProcess,
              location: value.plantName,
              deliveryPoint: value.deliveryPoint,
              packageCode: value.packageCode || '',
              delAddress: value.delAddress,
              day1: '<td><div class="fullRow">' + value.obj1.day1.totalNumberofBoxes + '</div></td>',
              day2: '<td "><div class="fullRow" >' + value.obj1.day2.totalNumberofBoxes + '</div></td>',
              day3: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.totalNumberofBoxes + '</div></td>',
              day4: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.totalNumberofBoxes + '</div></td>',
              day5: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.totalNumberofBoxes + '</div></td>',
              day6: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.totalNumberofBoxes + '</div></td>',
              day7: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.totalNumberofBoxes + '</div></td>' + '</div></td>',
              day8: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.totalNumberofBoxes + '</div></td>' + '</div></td>',
              day9: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.totalNumberofBoxes + '</div></td>',
              day10: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.totalNumberofBoxes + '</div></td>',
              day11: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.totalNumberofBoxes + '</div></td>',
              day12: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.totalNumberofBoxes + '</div></td>',
              day13: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.totalNumberofBoxes + '</div></td>',
              day14: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.totalNumberofBoxes + '</div></td>',
              day15: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.totalNumberofBoxes + '</div></td>',
              day16: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.totalNumberofBoxes + '</div></td>',
              day17: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.totalNumberofBoxes + '</div></td>',
              day18: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.totalNumberofBoxes + '</div></td>',
              day19: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.totalNumberofBoxes + '</div></td>',
              day20: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.totalNumberofBoxes + '</div></td>',
              day21: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.totalNumberofBoxes + '</div></td>',
              day22: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.totalNumberofBoxes + '</div></td>',
              day23: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.totalNumberofBoxes + '</div></td>',
              day24: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.totalNumberofBoxes + '</div></td>',
              day25: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.totalNumberofBoxes + '</div></td>',
              day26: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.totalNumberofBoxes + '</div></td>',
              day27: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.totalNumberofBoxes + '</div></td>',
              day28: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.totalNumberofBoxes + '</div></td>',
              day29: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.totalNumberofBoxes + '</div></td>',
              day30: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.totalNumberofBoxes + '</div></td>',
              day31: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.totalNumberofBoxes + '</div></td>',
              specification:
                '<td class="no-pad rmPad"><div class="fullRow">No. of Boxes</div></td>'
            };
          }
          else {
            partArr = {
              supplierCode: value.supplierCode,
              partNumber: value.partNumber,
              nextProcess: value.nextProcess,
              location: value.plantName,
              deliveryPoint: value.deliveryPoint,
              packageCode: value.packageCode || '',
              delAddress: value.delAddress,
              day1: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day1.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day1.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day1.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day1.totalNumberofBoxes + '</div></td>',
              day2: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day2.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day2.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day2.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day2.totalNumberofBoxes + '</div></td>',
              day3: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day3.totalNumberofBoxes + '</div></td>',
              day4: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day4.totalNumberofBoxes + '</div></td>',
              day5: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day5.totalNumberofBoxes + '</div></td>',
              day6: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day6.totalNumberofBoxes + '</div></td>',
              day7: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day7.totalNumberofBoxes + '</div></td>',
              day8: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day8.totalNumberofBoxes + '</div></td>',
              day9: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day9.totalNumberofBoxes + '</div></td>',
              day10: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day10.totalNumberofBoxes + '</div></td>',
              day11: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day11.totalNumberofBoxes + '</div></td>',
              day12: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day12.totalNumberofBoxes + '</div></td>',
              day13: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day13.totalNumberofBoxes + '</div></td>',
              day14: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day14.totalNumberofBoxes + '</div></td>',
              day15: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day15.totalNumberofBoxes + '</div></td>',
              day16: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day16.totalNumberofBoxes + '</div></td>',
              day17: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day17.totalNumberofBoxes + '</div></td>',
              day18: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day18.totalNumberofBoxes + '</div></td>',
              day19: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day19.totalNumberofBoxes + '</div></td>',
              day20: '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow" >' + value.obj1.day20.totalNumberofBoxes + '</div></td>',
              day21: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.Volume
                + '</div></td>' + '<td class="fullRow"><div class="fullRow">' + value.obj1.day21.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day21.totalNumberofBoxes + '</div></td>',
              day22: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day22.totalNumberofBoxes + '</div></td>',
              day23: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day23.totalNumberofBoxes + '</div></td>',
              day24: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day24.totalNumberofBoxes + '</div></td>',
              day25: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day25.totalNumberofBoxes + '</div></td>',
              day26: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day26.totalNumberofBoxes + '</div></td>',
              day27: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day27.totalNumberofBoxes + '</div></td>',
              day28: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day28.totalNumberofBoxes + '</div></td>',
              day29: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day29.totalNumberofBoxes + '</div></td>',
              day30: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day30.totalNumberofBoxes + '</div></td>',
              day31: '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.weight + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.Volume
                + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.Quantity + '</div></td>' + '<td class="no-pad rmPad"><div class="fullRow">' + value.obj1.day31.totalNumberofBoxes + '</div></td>',
              specification:
                '<td class="no-pad rmPad"><div class="fullRow">Weight(Kg)</div></td>' +
                '<td class="no-pad rmPad"><div class="fullRow">Volume(mm3)</div></td>' +
                '<td class="no-pad rmPad"><div class="fullRow">Quantity</div></td>' +
                '<td class="no-pad rmPad"><div class="fullRow">No. Of Boxes</div></td>'
            };
          }

          partsData.push(partArr);
        });
        this.poFixedData = partsData;
        console.log(this.poFixedData)
        this.dataSource=new MatTableDataSource<LedgerData[]>(this.poFixedData);
        this.data = partsData;
        this.length = this.poFixed.response.totalElements;
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }
    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
  }

  setFilterData(page) {
    this.spinner.show();
    let suppCode = [];
    let dataResult: any;
    let suppCodeDD = [];
    let pageNo;

    if (page == undefined || page == "null") {
      pageNo = 0;
    } else {
      pageNo = page - 1;
    }

    let dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      location: [],
      suplierCode: []
    };
    let userDetJson = JSON.parse(localStorage.getItem('userDetails'));
    this.logbaseService.getPoFixedDaily(dataToSend).subscribe(result => {
      dataResult = result;
      this.spinner.hide();
    });
  };

  toGetSupplierCode() {
    this.spinner.show();
    this.logbaseService.getAllSupplierCode({ "supplierCodes": [] }).subscribe(result => {
      let supplierCode;
      supplierCode = result;
      let suppCodeDD = [];
      if (supplierCode.response.length > 0) {
        supplierCode.response.forEach(function (value, key) {
          suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value.supplierCode });
        });
      }
      this.suppCodeList = suppCodeDD;
      this.spinner.hide();
    });
  }

  onSupplierCodeSelect(item: any) {
    this.locCodeTbl = [];
    this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
  }
  OnSupplierCodeDeSelect(item: any) {
    this.locCodeTbl = [];
    if (this.suppCodeTbl.length > 0) {
      this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
    } else {
      this.locCodeList = [];
      this.onChangeTable(this.config, true);
    }
  }

  onSupplierCodeSelectAll(items: any) {
    this.locCodeTbl = [];
    this.toGetLocationCode(this.toGetFormatedsendBody(items));
  }

  onSupplierCodeDeSelectAll(items: any) {
    this.locCodeTbl = [];
    this.locCodeList = [];
    this.onChangeTable(this.config, true);
  }

  toGetLocationCode(locationCode) {
    this.spinner.show();
    this.logbaseService.getAllSupplierCode(locationCode).subscribe(result => {
      let LocationCode;
      LocationCode = result;
      let temp = []
      if (LocationCode.response.length > 0) {
        for (let index = 0; index < LocationCode.response.length; index++) {
          if (LocationCode.response.length > 0) {
            if (LocationCode.response[index].locationDetails !== undefined &&
              LocationCode.response[index].locationDetails.length > 0) {
              for (let j = 0; j < LocationCode.response[index].locationDetails.length; j++) {
                temp.push(LocationCode.response[index].locationDetails[j]);
              }
            }
          }
        }
      }
      let locCodeDD = [];
      if (temp.length > 0) {
        temp.forEach(function (value, key) {
          locCodeDD.push({ id: locCodeDD.length + 1, itemName: value });
        });
      } else {
        locCodeDD = [];
      }
      const resultArray = [];
      const map = new Map();
      for (const item of locCodeDD) {
        if (!map.has(item.itemName)) {
          map.set(item.itemName, true);    // set any value to Map
          resultArray.push({
            id: item.id,
            itemName: item.itemName
          });
        }
      }
      let uniqueArray = []
      if (resultArray.length > 0) {
        resultArray.forEach(function (value, key) {
          uniqueArray.push({ id: uniqueArray.length + 1, itemName: value.itemName.location });
        });

      }

      this.locCodeList = uniqueArray;
      this.spinner.hide();
    });
  }

  toGetFormatedsendBody(data) {
    let returnBody = { "supplierCodes": [] }
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        returnBody.supplierCodes.push(data[index].itemName);
      }
    }
    return returnBody
  }

  resetDD() {
    this.locCodeTbl = [];
    this.suppCodeTbl1 = [];
    this.locCode = [];
    this.supPoint = [];
    this.onChangeTable(this.config, true);
  }

  public exportTable(config: any = this.config,
    page: any = { page: 0, itemsPerPage: this.itemsPerPage }
  ): any {
    let allselected = this.name;
    this.spinner.show();
    var pageNo;
    let sortData;
    let locSelected = [];
    let suppSelected = [];
    if (page) {
    }

    if (page.page == undefined || page.page == null) {
      pageNo = 0;
    } else {
      if (page.page != 0) {
        pageNo = page.page - 1;
      }
    }

    // To enable export feature
    // if (this.suppCodeTbl || this.locCodeTbl) {
    //   if ((this.suppCodeTbl.length > 0 && this.suppCodeTbl.length <= 10) || (this.locCodeTbl.length > 0 && this.locCodeTbl.length <= 10)) {
    //     this.enableExport = true;
    //   } else {
    //     this.enableExport = false;
    //   }
    // }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else {
        sortData = {
          name: "",
          sort: ""
        };
      }
    });

    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {

      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }
    if (this.suppCodeTbl1) {

    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }
    let dataToSend = {
      pageNum: 0,
      searchValue: this.config.filtering.filterString,
      size: this.poFixed.response.totalElements,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      location: locSelected,
      suplierCode: suppSelected
    };

    this.logbaseService.getPoFixedDaily(dataToSend).subscribe(result => {
      this.poFixedExportData = result;
      let poFixedExportResult = this.poFixedExportData.response.content;
      var finalobjExport = [];
      poFixedExportResult.forEach(x => {
        var obj: any = {};
        // var dlyAddress;
        // if (x.shippingInfoList) {
        //   dlyAddress = x.shippingInfoList[0].shippingPointaddrStreet + "," + x.shippingInfoList[0].shippingPointaddrCity + "," + x.shippingInfoList[0].shippingPointaddrCountry + "," + x.shippingInfoList[0].shippingPointaddrZipCode
        // } else {
        //   dlyAddress = "";
        // }

        obj.supplierCode = x.supplierCode;
        obj.packageId = x.packageId;
        obj.partNumber = x.partNumber;
        obj.plantName = x.plantName;
        obj.deliveryPoint = x.deliveryPoint;
        obj.nextProcess = x.nextProcess;
        //obj.delAddress = dlyAddress;
        obj.packageCode = x.packageCode;
        obj.month1Details = x.month1Details;
        obj.month2Details = x.month2Details;
        obj.month3Details = x.month3Details;
        obj.month4Details = x.month4Details;
        obj.month5Details = x.month5Details;
        obj.month6Details = x.month6Details;
        obj.month7Details = x.month7Details;
        obj.month8Details = x.month8Details;
        obj.month9Details = x.month9Details;
        obj.month10Details = x.month10Details;
        obj.month11Details = x.month11Details;
        obj.month12Details = x.month12Details;

        finalobjExport.push(obj);
      });
      finalobjExport.forEach(x => {
        x.datesdata = [];
        var flattened1 = [].concat.apply([], x.month1Details);
        var flattened2 = [].concat.apply([], x.month2Details);
        var flattened3 = [].concat.apply([], x.month3Details);
        var flattened4 = [].concat.apply([], x.month4Details);
        var flattened5 = [].concat.apply([], x.month5Details);
        var flattened6 = [].concat.apply([], x.month6Details);
        var flattened7 = [].concat.apply([], x.month7Details);
        var flattened8 = [].concat.apply([], x.month8Details);
        var flattened9 = [].concat.apply([], x.month9Details);
        var flattened10 = [].concat.apply([], x.month10Details);
        var flattened11 = [].concat.apply([], x.month11Details);
        var flattened12 = [].concat.apply([], x.month12Details);
        x.datesdata = flattened1.concat(flattened2).concat(flattened3).concat(flattened4).concat(flattened5).concat(flattened6).concat(flattened7).concat(flattened8).concat(flattened9).concat(flattened10).concat(flattened11).concat(flattened12);
      });

      finalobjExport.forEach(x => {
        x.datesdata = x.datesdata.filter(y => {
          return this.dateFormatData.includes(y.date);
        })
      });
      finalobjExport.forEach(obj => {
        var myobj = {}
        for (var x = 1; x <= 31; x++) {
          var innerobj = obj.datesdata.find(y => {
            return this.dateFormatData[x + 1] == y.date;
          }) != undefined ? obj.datesdata.find(y => {
            return this.dateFormatData[x + 1] == y.date;
          }) : { totalWeight: 0, Volume: 0, totalVolume: 0, totalQuantity: 0, totalNumberOfBox: 0 };
          myobj["day" + "" + x] = { weight: innerobj.totalWeight, Volume: innerobj.totalVolume, Quantity: innerobj.totalQuantity, totalNumberofBoxes: innerobj.totalNumberOfBox };
        }
        obj.obj1 = myobj;
      });
      this.spinner.hide();
      this.exportCSV(finalobjExport);
    });
  }
  exportCSV(exportData) {
    this.exportData = exportData;
    let csvData = [];
    let specName = this.name;
    let daysData = []

    this.exportData.forEach(function (value, key) {
      var csvObj: any = {};

      csvObj.supplierCode = value.supplierCode;
      csvObj.partNo = value.partNumber;
      csvObj.location = value.plantName;
      csvObj.deliveryPoint = value.deliveryPoint;
      csvObj.lineNumber = value.nextProcess;
      csvObj.packageCode = value.packageCode;
      csvObj.specification = specName;
      if (specName == 'Quantity') {
        csvObj["day1"] = value.obj1.day1.Quantity;
        csvObj["day2"] = value.obj1.day2.Quantity;
        csvObj["day3"] = value.obj1.day3.Quantity;
        csvObj["day4"] = value.obj1.day4.Quantity;
        csvObj["day5"] = value.obj1.day5.Quantity;
        csvObj["day6"] = value.obj1.day6.Quantity;
        csvObj["day7"] = value.obj1.day7.Quantity;
        csvObj["day8"] = value.obj1.day8.Quantity;
        csvObj["day9"] = value.obj1.day9.Quantity;
        csvObj["day10"] = value.obj1.day10.Quantity;
        csvObj["day11"] = value.obj1.day11.Quantity;
        csvObj["day12"] = value.obj1.day12.Quantity;
        csvObj["day13"] = value.obj1.day13.Quantity;
        csvObj["day14"] = value.obj1.day14.Quantity;
        csvObj["day15"] = value.obj1.day15.Quantity;
        csvObj["day16"] = value.obj1.day16.Quantity;
        csvObj["day17"] = value.obj1.day17.Quantity;
        csvObj["day18"] = value.obj1.day18.Quantity;
        csvObj["day19"] = value.obj1.day19.Quantity;
        csvObj["day20"] = value.obj1.day20.Quantity;
        csvObj["day21"] = value.obj1.day21.Quantity;
        csvObj["day22"] = value.obj1.day22.Quantity;
        csvObj["day23"] = value.obj1.day23.Quantity;
        csvObj["day24"] = value.obj1.day24.Quantity;
        csvObj["day25"] = value.obj1.day25.Quantity;
        csvObj["day26"] = value.obj1.day26.Quantity;
        csvObj["day27"] = value.obj1.day27.Quantity;
        csvObj["day28"] = value.obj1.day28.Quantity;
        csvObj["day29"] = value.obj1.day29.Quantity;
        csvObj["day30"] = value.obj1.day30.Quantity;
        csvObj["day31"] = value.obj1.day31.Quantity;
      }
      else if (specName == 'Weight') {
        csvObj["day1"] = value.obj1.day1.weight;
        csvObj["day2"] = value.obj1.day2.weight;
        csvObj["day3"] = value.obj1.day3.weight;
        csvObj["day4"] = value.obj1.day4.weight;
        csvObj["day5"] = value.obj1.day5.weight;
        csvObj["day6"] = value.obj1.day6.weight;
        csvObj["day7"] = value.obj1.day7.weight;
        csvObj["day8"] = value.obj1.day8.weight;
        csvObj["day9"] = value.obj1.day9.weight;
        csvObj["day10"] = value.obj1.day10.weight;
        csvObj["day11"] = value.obj1.day11.weight;
        csvObj["day12"] = value.obj1.day12.weight;
        csvObj["day13"] = value.obj1.day13.weight;
        csvObj["day14"] = value.obj1.day14.weight;
        csvObj["day15"] = value.obj1.day15.weight;
        csvObj["day16"] = value.obj1.day16.weight;
        csvObj["day17"] = value.obj1.day17.weight;
        csvObj["day18"] = value.obj1.day18.weight;
        csvObj["day19"] = value.obj1.day19.weight;
        csvObj["day20"] = value.obj1.day20.weight;
        csvObj["day21"] = value.obj1.day21.weight;
        csvObj["day22"] = value.obj1.day22.weight;
        csvObj["day23"] = value.obj1.day23.weight;
        csvObj["day24"] = value.obj1.day24.weight;
        csvObj["day25"] = value.obj1.day25.weight;
        csvObj["day26"] = value.obj1.day26.weight;
        csvObj["day27"] = value.obj1.day27.weight;
        csvObj["day28"] = value.obj1.day28.weight;
        csvObj["day29"] = value.obj1.day29.weight;
        csvObj["day30"] = value.obj1.day30.weight;
        csvObj["day31"] = value.obj1.day31.weight;

      }

      else if (specName == 'Volume') {
        csvObj["day1"] = value.obj1.day1.Volume;
        csvObj["day2"] = value.obj1.day2.Volume;
        csvObj["day3"] = value.obj1.day3.Volume;
        csvObj["day4"] = value.obj1.day4.Volume;
        csvObj["day5"] = value.obj1.day5.Volume;
        csvObj["day6"] = value.obj1.day6.Volume;
        csvObj["day7"] = value.obj1.day7.Volume;
        csvObj["day8"] = value.obj1.day8.Volume;
        csvObj["day9"] = value.obj1.day9.Volume;
        csvObj["day10"] = value.obj1.day10.Volume;
        csvObj["day11"] = value.obj1.day11.Volume;
        csvObj["day12"] = value.obj1.day12.Volume;
        csvObj["day13"] = value.obj1.day13.Volume;
        csvObj["day14"] = value.obj1.day14.Volume;
        csvObj["day15"] = value.obj1.day15.Volume;
        csvObj["day16"] = value.obj1.day16.Volume;
        csvObj["day17"] = value.obj1.day17.Volume;
        csvObj["day18"] = value.obj1.day18.Volume;
        csvObj["day19"] = value.obj1.day19.Volume;
        csvObj["day20"] = value.obj1.day20.Volume;
        csvObj["day21"] = value.obj1.day21.Volume;
        csvObj["day22"] = value.obj1.day22.Volume;
        csvObj["day23"] = value.obj1.day23.Volume;
        csvObj["day24"] = value.obj1.day24.Volume;
        csvObj["day25"] = value.obj1.day25.Volume;
        csvObj["day26"] = value.obj1.day26.Volume;
        csvObj["day27"] = value.obj1.day27.Volume;
        csvObj["day28"] = value.obj1.day28.Volume;
        csvObj["day29"] = value.obj1.day29.Volume;
        csvObj["day30"] = value.obj1.day30.Volume;
        csvObj["day31"] = value.obj1.day31.Volume;
      }
      if (specName == 'No. Of Boxes') {
        csvObj["day1"] = value.obj1.day1.totalNumberofBoxes;
        csvObj["day2"] = value.obj1.day2.totalNumberofBoxes;
        csvObj["day3"] = value.obj1.day3.totalNumberofBoxes;
        csvObj["day4"] = value.obj1.day4.totalNumberofBoxes;
        csvObj["day5"] = value.obj1.day5.totalNumberofBoxes;
        csvObj["day6"] = value.obj1.day6.totalNumberofBoxes;
        csvObj["day7"] = value.obj1.day7.totalNumberofBoxes;
        csvObj["day8"] = value.obj1.day8.totalNumberofBoxes;
        csvObj["day9"] = value.obj1.day9.totalNumberofBoxes;
        csvObj["day10"] = value.obj1.day10.totalNumberofBoxes;
        csvObj["day11"] = value.obj1.day11.totalNumberofBoxes;
        csvObj["day12"] = value.obj1.day12.totalNumberofBoxes;
        csvObj["day13"] = value.obj1.day13.totalNumberofBoxes;
        csvObj["day14"] = value.obj1.day14.totalNumberofBoxes;
        csvObj["day15"] = value.obj1.day15.totalNumberofBoxes;
        csvObj["day16"] = value.obj1.day16.totalNumberofBoxes;
        csvObj["day17"] = value.obj1.day17.totalNumberofBoxes;
        csvObj["day18"] = value.obj1.day18.totalNumberofBoxes;
        csvObj["day19"] = value.obj1.day19.totalNumberofBoxes;
        csvObj["day20"] = value.obj1.day20.totalNumberofBoxes;
        csvObj["day21"] = value.obj1.day21.totalNumberofBoxes;
        csvObj["day22"] = value.obj1.day22.totalNumberofBoxes;
        csvObj["day23"] = value.obj1.day23.totalNumberofBoxes;
        csvObj["day24"] = value.obj1.day24.totalNumberofBoxes;
        csvObj["day25"] = value.obj1.day25.totalNumberofBoxes;
        csvObj["day26"] = value.obj1.day26.totalNumberofBoxes;
        csvObj["day27"] = value.obj1.day27.totalNumberofBoxes;
        csvObj["day28"] = value.obj1.day28.totalNumberofBoxes;
        csvObj["day29"] = value.obj1.day29.totalNumberofBoxes;
        csvObj["day30"] = value.obj1.day30.totalNumberofBoxes;
        csvObj["day31"] = value.obj1.day31.totalNumberofBoxes;
      }
      csvData.push(csvObj);
    })
    let exportDate = []
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      // showTitle: true,
      title: 'PO Forecast Daily',
      headers: ['Supplier', 'Part No', 'Location', 'Delivery Point', 'Next Process', 'Package Code', 'Spec', this.poFixedDates],
      removeNewLines: true
    };
    new AngularCsv(csvData, 'Po Fixed Daily', options);

  }

  // Download() {
  //   var csvData = new Blob([arg.data], {type: 'text/csv;charset=utf-8;'});
  //   var csvURL =  null;
  //   if (navigator.msSaveBlob) {
  //       csvURL = navigator.msSaveBlob(csvData, 'download.cv');
  //   } else {
  //       csvURL = window.URL.createObjectURL(csvData);
  //   }
  //   var tempLink = document.createElement('a');
  //   tempLink.href = csvURL;
  //   tempLink.setAttribute('download', 'download.cv');
  //   tempLink.click();
  // }
}
